interface CategoricalLegendItem {
  label: string;
  color: string;
}

interface CategoricalLegendPillProps {
  title: string;
  items: readonly CategoricalLegendItem[];
  variant?: 'map' | 'panel';
  className?: string;
}

/** Compact pill legend for categorical layers (e.g. flood risk levels). */
export function CategoricalLegendPill({
  title,
  items,
  variant = 'map',
  className = '',
}: CategoricalLegendPillProps) {
  const isMap = variant === 'map';

  return (
    <div
      className={`select-none ${
        isMap
          ? 'inline-flex flex-col rounded-full bg-neutral-400/95 px-2.5 py-1 text-black shadow-sm backdrop-blur-[2px] dark:bg-neutral-600/95 dark:text-white'
          : `mx-2 mb-2 rounded-lg border border-gray-200/80 bg-gray-50/90 px-2.5 py-2 dark:border-gray-700/60 dark:bg-gray-800/50 ${className}`
      }`}
      role="img"
      aria-label={`${title} legend`}
    >
      <p
        className={`font-medium leading-none ${
          isMap ? 'mb-1 text-[9px]' : 'mb-1.5 text-[11px] text-gray-700 dark:text-gray-200'
        }`}
      >
        {title}
      </p>
      <div className="flex items-center gap-0.5">
        {items.map(({ label, color }) => (
          <div key={label} className="flex flex-col items-center gap-0.5">
            <span
              className={`block rounded-[2px] border border-black/15 ${
                isMap ? 'h-[5px] w-[30px]' : 'h-[7px] w-[36px]'
              }`}
              style={{ backgroundColor: color }}
              aria-hidden
            />
            <span
              className={`whitespace-nowrap leading-none ${
                isMap ? 'text-[7px]' : 'text-[9px] text-gray-600 dark:text-gray-400'
              }`}
            >
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
